// ══════════════════════════════════════════════════════════════════
//  Queries de usuários por papel (TanStack Query).
//  Lista de SDRs/Closers muda pouco → staleTime alto (10 min).
//  Dedupe entre Comissões, Agenda, MyPanel e filtros.
// ══════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { qk } from './keys';
import * as usersRepository from '@app';

const DEZ_MIN = 10 * 60 * 1000;

export function useUsersByRole(workspaceId: string | undefined, role: 'sdr' | 'closer') {
  return useQuery({
    queryKey: qk.users.byRole(workspaceId ?? '', role),
    queryFn: () => usersRepository.listUsersByRole(workspaceId as string, role),
    enabled: !!workspaceId,
    staleTime: DEZ_MIN,
    gcTime: 2 * DEZ_MIN,
  });
}

export const useClosers = (workspaceId?: string) => useUsersByRole(workspaceId, 'closer');
export const useSdrs = (workspaceId?: string) => useUsersByRole(workspaceId, 'sdr');
